import React from 'react';

const KibanaIcon = () => {
  return (
    React.createElement('svg', { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48"   , width: "24px", height: "24px",}, React.createElement('polygon', { fill: "#ec407a", points: "10,41 10,5 40,5"  ,} ), React.createElement('path', { fill: "#4db6ac", d: "M40.659,44C38.492,29.843,26.262,19,11.5,19c-0.503,0-1.003,0.013-1.5,0.038V44H40.659z",} ), React.createElement('path', { fill: "#009688", d: "M10,41.2V44h5.667l14.958-17.949c-1.564-1.334-3.271-2.503-5.092-3.49L10,41.2z",} ), React.createElement('path', { fill: "#212121", d: "M11.5,19c-0.503,0-1.003,0.013-1.5,0.038V24v17l15.412-18.495C21.266,20.28,16.536,19,11.5,19z",} ))
  )
}

export default KibanaIcon